import React from "react";
import classnames from "classnames";

import { TestCase } from "types/test_cases";

type TestCasesListProps = {
  testCases: Array<TestCase>;
};

const DEFAULT_NUMBER_OF_TEST_CASES_TO_SHOW = 5;

function TestCasesList({ testCases }: TestCasesListProps): JSX.Element {
  const rowClass = (index: number) =>
    classnames("flex justify-between border-b border-light py-sm items-center", index === 0 ? "border-t" : "");

  return (
    <div className="mt-md">
      {testCases.length > DEFAULT_NUMBER_OF_TEST_CASES_TO_SHOW && (
        <div className="mb-xl text-sm">Here are some of the test cases that you have imported.</div>
      )}
      {testCases.slice(-DEFAULT_NUMBER_OF_TEST_CASES_TO_SHOW).map((testCase, index) => (
        <div className={rowClass(index)} key={`${testCase.code} ${testCase.name}`}>
          <span data-testid="test-case-name">{`${testCase.code} ${testCase.name}`}</span>
        </div>
      ))}
    </div>
  );
}

export default TestCasesList;
